<template>
  <div>
    <!-- Delete Modal -->
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteItem" />

    <!-- Create / Edit Modal -->
    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('incubator.Add-Incubator')
          : $t('incubator.Edit-Incubator')
      "
    >
      <b-card-text>
        <b-row>
          <!-- Name -->
          <b-col md="6">
            <b-form-group :label="$t('incubator.name')" label-for="name">
              <b-form-input
                id="name"
                v-model="editForm.name"
                :placeholder="$t('incubator.name')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.name }}
              </p>
            </b-form-group>
          </b-col>

          <!-- Brand -->
          <b-col md="6">
            <b-form-group :label="$t('incubator.brand')" label-for="brand">
              <b-form-input
                id="brand"
                v-model="editForm.brand"
                :placeholder="$t('incubator.brand')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.brand }}
              </p>
            </b-form-group>
          </b-col>

          <!-- Incubator Type -->
          <b-col md="6">
            <AutoComplete
              v-model="editForm.incubator_type_id"
              :label="$t('incubator.incubator_type')"
              :placeholder="$t('incubator.incubator_type')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="incubatorTypes"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.incubator_type_id }}
            </p>
          </b-col>

          <!-- Floor -->
          <b-col md="6">
            <AutoComplete
              v-model="editForm.floor_id"
              :label="$t('incubator.floor')"
              :placeholder="$t('incubator.floor')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="floor?take=1000"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.floor_id }}
            </p>
          </b-col>

          <!-- Room -->
          <b-col md="6">
            <AutoComplete
              v-model="editForm.room_id"
              :label="$t('incubator.room')"
              :placeholder="$t('incubator.room')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="room?take=10000"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.room_id }}
            </p>
          </b-col>

          <!-- Doctor -->
          <!-- <b-col md="6">
            <AutoComplete
              v-model="editForm.doctor_id"
              :label="$t('Doctor')"
              :placeholder="$t('Doctor')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="doctor/nicu?take=1000"
              text-title="name"
              keyword="name"
            />
            <p class="text-danger mt-1">
              {{ errorForm.doctor_id }}
            </p>
          </b-col> -->

          <!-- Active -->
          <b-col md="6">
            <b-form-group
              :label="$t('incubator.is_active')"
              label-for="is_active"
            >
              <v-select
                id="is_active"
                v-model="editForm.is_active"
                :options="activeOptions"
                :reduce="(o) => o.value"
                label="label"
                :placeholder="$t('incubator.is_active')"
                :clearable="false"
              />
              <p class="text-danger mt-1">
                {{ errorForm.is_active }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>

      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="loading"
          block
          @click="submitItem"
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.save")
          }}</span>
          <b-spinner v-else small />
        </b-button>
      </template>
    </b-modal>

    <!-- CONTENT (guarded by list permission) -->
    <div v-if="canList">
      <b-card :title="$t('incubator.Incubators')">
        <!-- Filters -->
        <b-row>
          <b-col cols="12" md="12">
            <h2 class="mb-2">
              {{ $t("incubator.Filter-Incubators") }}
            </h2>
          </b-col>

          <b-col md="3" cols="12">
            <b-form-group :label="$t('incubator.name')" label-for="filter_name">
              <b-form-input
                id="filter_name"
                v-model="filters.name"
                :placeholder="$t('incubator.name')"
                @keyup.enter="getIncubatorsList"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="12">
            <b-form-group
              :label="$t('incubator.brand')"
              label-for="filter_brand"
            >
              <b-form-input
                id="filter_brand"
                v-model="filters.brand"
                :placeholder="$t('incubator.brand')"
                @keyup.enter="getIncubatorsList"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="12">
            <AutoComplete
              v-model="filters.floor_id"
              :label="$t('incubator.floor')"
              :placeholder="$t('incubator.floor')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="floor?take=1000"
              text-title="name"
              keyword="name"
            />
          </b-col>

          <b-col md="3" cols="12">
            <AutoComplete
              v-model="filters.room_id"
              :label="$t('incubator.room')"
              :placeholder="$t('incubator.room')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="room?take=10000"
              text-title="name"
              keyword="name"
            />
          </b-col>

          <b-col md="3" cols="12">
            <b-form-group
              :label="$t('incubator.is_available')"
              label-for="filter_available_status"
            >
              <v-select
                id="filter_available_status"
                v-model="filters.available_status"
                :options="filterActiveOptions"
                :reduce="(o) => o.value"
                label="label"
                :placeholder="$t('incubator.is_available')"
                clearable
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search -->
        <b-row class="mb-2">
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button variant="primary" @click="getIncubatorsList">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>

        <!-- Header + Add -->
        <div class="d-flex justify-content-between mt-2 mb-2">
          <h2 class="h4 m-0">
            {{ $t("incubator.Incubators") }}
          </h2>
          <b-button
            v-if="canCreate"
            variant="primary"
            @click="show(null, 'create')"
          >
            {{ $t("incubator.Add-Incubator") }}
          </b-button>
        </div>

        <!-- Table -->
        <b-table
          v-if="!loading"
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('common.no_results')"
          class="position-relative"
        >
          <!-- Incubator Type -->
          <template #cell(incubator_type)="ctx">
            <span class="font-weight-bold">
              {{ getNestedProperty(ctx.item, "incubator_type.name", "N/A") }}
            </span>
          </template>

          <!-- Floor -->
          <template #cell(floor)="ctx">
            <span>
              {{ getNestedProperty(ctx.item, "floor.name", "N/A") }}
            </span>
          </template>

          <!-- Room -->
          <template #cell(room)="ctx">
            <span>
              {{ getNestedProperty(ctx.item, "room.name", "N/A") }}
            </span>
          </template>

          <!-- Active Status -->
          <template #cell(is_active)="ctx">
            <b-badge
              :variant="ctx.item.is_active ? 'success' : 'secondary'"
              style="font-size: 1rem"
            >
              {{
                ctx.item.is_active
                  ? $t("incubator.active")
                  : $t("incubator.inactive")
              }}
            </b-badge>
          </template>

          <!-- Available Status -->
          <template #cell(is_available)="ctx">
            <b-badge
              :variant="ctx.item.is_available ? 'success' : 'warning'"
              style="font-size: 1rem"
            >
              {{
                ctx.item.is_available
                  ? $t("incubator.available")
                  : $t("incubator.unavailable")
              }}
            </b-badge>
          </template>

          <!-- Created At -->
          <template #cell(created_at)="ctx">
            <span class="text-muted">
              {{ ctx.item.created_at }}
            </span>
          </template>

          <template #cell(actions)="ctx">
            <div class="text-nowrap">
              <ActionsButtons
                :edit-perm="'update-incubator'"
                :delete-perm="'delete-incubator'"
                :can-edit="canUpdate"
                :can-delete="canDelete"
                @editToggle="show(ctx.item)"
                @deleteToggle="deleteModel(ctx.item)"
              />
            </div>
          </template>
        </b-table>

        <!-- Loading -->
        <div v-else class="d-flex justify-content-center mb-3">
          <b-spinner label="Loading..." />
        </div>

        <!-- Pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                {{
                  $t("common.showing_range", {
                    from: fromRow,
                    to: toRow,
                    total: dataCount,
                  })
                }}
              </span>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getIncubatorsList"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <!-- No permission state -->
    <div v-else class="text-center py-5 text-muted">
      {{ $t("common.no_permission") }}
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BFormTextarea,
  BTable,
  BPagination,
  BSpinner,
  BCardText,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { getNestedProperty } from "@/utils/nestedProperty.js";

import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BFormTextarea,
    BTable,
    BPagination,
    BSpinner,
    BCardText,
    BBadge,
    vSelect,
    AutoComplete,
    ActionsButtons,
    DeleteModal,
  },
  mixins: [permissionChecker],

  data() {
    return {
      // paging
      take: 10,
      page: 1,
      dataCount: 0,
      loading: true,

      // list
      data: [],

      // filters
      filters: {
        name: "",
        brand: "",
        floor_id: "",
        room_id: "",
        is_active: null, // null | 1 | 0
      },

      // form
      editForm: {
        incubator_type_id: "",
        name: "",
        brand: "",
        floor_id: "",
        room_id: "",
        doctor_id: "",
        is_active: 1, // 1|0
        _method: "PUT",
      },
      createMode: false,
      idItem: null,

      errorForm: {
        incubator_type_id: "",
        name: "",
        brand: "",
        floor_id: "",
        room_id: "",
        doctor_id: "",
        is_active: "",
      },

      // table columns
      tableColumns: [
        { key: "name", label: this.$t("incubator.name"), sortable: true },
        {
          key: "is_available",
          label: this.$t("incubator.is_available"),
          sortable: true,
        },
        { key: "brand", label: this.$t("incubator.brand"), sortable: true },
        {
          key: "incubator_type",
          label: this.$t("incubator.incubator_type"),
          sortable: false,
        },
        { key: "floor", label: this.$t("incubator.floor"), sortable: false },
        { key: "room", label: this.$t("incubator.room"), sortable: false },
        {
          key: "is_active",
          label: this.$t("incubator.is_active"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("common.created-at"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
          thStyle: { width: "120px" },
        },
      ],

      // selects
      activeOptions: [
        { label: this.$t("incubator.active"), value: 1 },
        { label: this.$t("incubator.inactive"), value: 0 },
      ],
      filterActiveOptions: [
        { label: this.$t("incubator.active"), value: 1 },
        { label: this.$t("incubator.inactive"), value: 0 },
      ],
    };
  },

  computed: {
    // permission flags (script-only usage)
    canList() {
      return this.hasPermission("get-incubator");
    },
    canCreate() {
      return this.hasPermission("store-incubator");
    },
    canUpdate() {
      return this.hasPermission("update-incubator");
    },
    canDelete() {
      return this.hasPermission("delete-incubator");
    },

    fromRow() {
      if (!this.dataCount) return 0;
      return (this.page - 1) * this.take + 1;
    },
    toRow() {
      const to = this.page * this.take;
      return to > this.dataCount ? this.dataCount : to;
    },
  },

  watch: {
    page() {
      if (this.canList) this.getIncubatorsList();
    },
  },

  mounted() {
    this.getIncubatorsList();
  },

  methods: {
    getNestedProperty,

    /** unified permission helper (array | object | string) */
    hasPermission(key) {
      try {
        const store = this.$store;
        if (!store || !store.state || !store.state.app) return false;
        const perms = store.state.app.permissions;
        if (!perms) return false;

        if (Array.isArray(perms)) return perms.indexOf(key) !== -1;
        if (typeof perms === "object") return !!perms[key];
        if (typeof perms === "string")
          return (
            perms
              .split(",")
              .map((s) => s.trim())
              .indexOf(key) !== -1
          );
        return false;
      } catch (e) {
        return false;
      }
    },

    // LIST
    async getIncubatorsList() {
      this.loading = true;
      let url = `/incubators?include=incubatorType,floor,room&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.filters.name)
        url += `&filter[name]=${encodeURIComponent(this.filters.name)}`;
      if (this.filters.brand)
        url += `&filter[brand]=${encodeURIComponent(this.filters.brand)}`;
      if (this.filters.floor_id)
        url += `&filter[floor_id]=${encodeURIComponent(this.filters.floor_id)}`;
      if (this.filters.room_id)
        url += `&filter[room_id]=${encodeURIComponent(this.filters.room_id)}`;
      if (this.filters.is_available === 1 || this.filters.is_available === 0) {
        url += `&filter[is_available]=${this.filters.is_available}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    // OPEN MODAL
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.idItem = null;
        this.editForm = {
          incubator_type_id: "",
          name: "",
          brand: "",
          floor_id: "",
          room_id: "",
          doctor_id: "",
          is_active: 1,
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.idItem = item.id;
        this.editForm = {
          incubator_type_id:
            typeof item.incubator_type_id === "object"
              ? getNestedProperty(item, "incubator_type_id.id", "")
              : item.incubator_type_id || "",
          name: item.name || "",
          brand: item.brand || "",
          floor_id:
            typeof item.floor_id === "object"
              ? getNestedProperty(item, "floor_id.id", "")
              : item.floor_id || "",
          room_id:
            typeof item.room_id === "object"
              ? getNestedProperty(item, "room_id.id", "")
              : item.room_id || "",
          doctor_id:
            typeof item.doctor_id === "object"
              ? getNestedProperty(item, "doctor_id.id", "")
              : item.doctor_id || "",
          is_active:
            typeof item.is_active === "number"
              ? item.is_active
              : item.is_active
              ? 1
              : 0,
          _method: "PUT",
        };
      }
      this.$bvModal.show("modal-edit");
    },

    // DELETE
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },

    deleteItem() {
      this.$store
        .dispatch("delete", `/incubators/${this.deleteForm.id}`)
        .then(() => {
          this.getIncubatorsList();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$t("common.delete_success"),
              icon: "success",
              variant: "info",
              text: this.$t("incubator.deleted", {
                name: this.deleteForm.name || "",
              }),
            },
          });
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$t("common.error"),
              variant: "danger",
              text: this.$t("incubator.delete_error", {
                name: this.deleteForm.name || "",
              }),
            },
          });
        });
    },

    // SUBMIT
    submitItem() {
      this.loading = true;

      // reset errors
      Object.keys(this.errorForm).forEach((k) => (this.errorForm[k] = ""));

      // build/clean
      const payload = { ...this.editForm };

      // Extract IDs from objects if AutoComplete returned full objects
      if (
        typeof payload.incubator_type_id === "object" &&
        payload.incubator_type_id
      ) {
        payload.incubator_type_id = payload.incubator_type_id.id || "";
      }
      if (typeof payload.floor_id === "object" && payload.floor_id) {
        payload.floor_id = payload.floor_id.id || "";
      }
      if (typeof payload.room_id === "object" && payload.room_id) {
        payload.room_id = payload.room_id.id || "";
      }
      if (typeof payload.doctor_id === "object" && payload.doctor_id) {
        payload.doctor_id = payload.doctor_id.id || "";
      }

      Object.keys(payload).forEach((k) => {
        if (payload[k] === "" || payload[k] === null) delete payload[k];
      });

      // validations
      let invalid = false;
      if (!payload.incubator_type_id) {
        this.errorForm.incubator_type_id = this.$t(
          "incubator.required_incubator_type"
        );
        invalid = true;
      }
      if (!payload.name) {
        this.errorForm.name = this.$t("incubator.required_name");
        invalid = true;
      }
      if (!payload.brand) {
        this.errorForm.brand = this.$t("incubator.required_brand");
        invalid = true;
      }
      if (!payload.floor_id) {
        this.errorForm.floor_id = this.$t("incubator.required_floor");
        invalid = true;
      }
      if (!payload.room_id) {
        this.errorForm.room_id = this.$t("incubator.required_room");
        invalid = true;
      }
      if (payload.is_active !== 0 && payload.is_active !== 1) {
        this.errorForm.is_active = this.$t("incubator.required_is_active");
        invalid = true;
      }

      if (invalid) {
        this.loading = false;
        return;
      }

      if (this.createMode) {
        if (!this.canCreate) {
          this.loading = false;
          return;
        }
        const params = { form: payload, path: "/incubators" };
        this.$store
          .dispatch("create", params)
          .then(() => {
            this.getIncubatorsList();
            this.$bvModal.hide("modal-edit");
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: this.$t("validation.error"),
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
      } else {
        if (!this.canUpdate) {
          this.loading = false;
          return;
        }
        const params = { form: payload, path: `/incubators/${this.idItem}` };
        this.$store
          .dispatch("update", params)
          .then(() => {
            this.getIncubatorsList();
            this.$bvModal.hide("modal-edit");
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: this.$t("validation.error"),
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}
.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}
.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}
.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

/* Table horizontal scroll - always visible */
.table-responsive,
.b-table-responsive,
.table > .table-responsive {
  overflow-x: scroll !important;
  overflow-y: visible !important;
  -webkit-overflow-scrolling: touch;
}

/* Make scrollbar always visible and styled - Webkit browsers */
.table-responsive::-webkit-scrollbar,
.b-table-responsive::-webkit-scrollbar {
  height: 14px !important;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.table-responsive::-webkit-scrollbar-track,
.b-table-responsive::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 8px;
  margin: 0 10px;
}

.table-responsive::-webkit-scrollbar-thumb,
.b-table-responsive::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 8px;
  border: 2px solid #f5f5f5;
}

.table-responsive::-webkit-scrollbar-thumb:hover,
.b-table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

/* For Firefox */
.table-responsive,
.b-table-responsive {
  scrollbar-width: auto !important;
  scrollbar-color: #888 #f5f5f5;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
